"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["url"],

  data: function data() {
    return {
      posting: false,
      text: null,
      oldInput: [],
      errors: []
    };
  },
  mounted: function mounted() {
    var requestData = this.$store.getters.pullRequestErrorsAndOldInputByAction("add-health-goal");
    this.errors = requestData.errors;
    this.oldInput = requestData.oldInput;

    if (!_.isEmpty(this.oldInput)) {
      this.text = this.oldInput.text || "";
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/menu/AddHealthGoalMenu.vue
// module id = UHkH
// module chunks = 0 1